import { Injectable } from '@angular/core';
import { constants } from '../../constants/constants';
import { TimeService } from '../time/time.service';
import { TIME_OF_DAY } from '../../enums/time-of-day.enum';

@Injectable({ providedIn: 'root' })
export class UserGreetingService {
	static getGreetingMessage(): string {
		let greeting;
		const time = TimeService.getTimeOfDay();

		switch (time) {
			case TIME_OF_DAY.MORNING:
				greeting = constants.USER_GREETING.GREETING_MORNING;
				break;
			case TIME_OF_DAY.AFTERNOON:
				greeting = constants.USER_GREETING.GREETING_AFTERNOON;
				break;
			case TIME_OF_DAY.EVENING:
				greeting = constants.USER_GREETING.GREETING_EVENING;
				break;
			default:
				greeting = constants.USER_GREETING.GREETING_GENERIC;
				break;
		}

		return greeting;
	}
}
